import APICall from "../utils/APICall";

export default class AccountServices {
  static removeRestriction = async (payload) => {
    return await APICall(
      `/api/NewAccount/admin/remove-account-restriction?accountNumber=${payload}`,
      "POST"
    );
  };
  static listAccounts = async (
    page,
    pageLimit,
    search,
    from,
    to,
    makerCheckerStatus,
    pndLifted,
    mandateUploaded,
    misCode
  ) => {
    var url = `/api/NewAccount/admin/list-accounts?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (from) url = `${url}&from=${from}`;
    if (to) url = `${url}&to=${to}`;
    if (makerCheckerStatus) url = `&makerCheckerStatus=${makerCheckerStatus}`;
    if (pndLifted) url = `&pndLifted=${pndLifted}`;
    if (mandateUploaded) url = `&mandateUploaded=${mandateUploaded}`;
    if (misCode) url = `&misCode=${misCode}`;
    return await APICall(url, "GET");
  };
  static exportAcct = async (search, from, to) => {
    return await APICall(
      `/api/NewAccount/admin/export-newAccount?search=${search}&from=${from}&to=${to}`,
      "GET"
    );
  };
  static viewAccout = async (payload) => {
    return await APICall(
      `/api/NewAccount/admin/view/Account?accountNumber=${payload}`,
      "GET"
    );
  };
  static listDocument = async (payload) => {
    return await APICall(
      `/api/NewAccountDocument/admin/list-account-document?userName=${payload}`,
      "GET"
    );
  };
  static viewDocument = async (documentTag) => {
    return await APICall(
      `/api/NewAccountDocument/admin/view-document?documentTag=${documentTag}`,
      "GET"
    );
  };
  static deleteDocument = async (payload) => {
    return await APICall(
      "/api/NewAccountDocument/admin/delete-account-document",
      "POST",
      payload
    );
  };
  static updateDoc = async (payload) => {
    return await APICall(
      "/api/NewAccountDocument/admin/review-account-document",
      "POST",
      payload
    );
  };
  static rejectDoc = async (payload) => {
    return await APICall(
      "/api/NewAccountDocument/admin/reject-account-document",
      "POST",
      payload
    );
  };
  static personalInfo = async (userName) => {
    return await APICall(
      `/api/Customer/admin/customer-personal-info?userName=${userName}`,
      "GET"
    );
  };
  static discardInfo = async (payload) => {
    return await APICall(
      "/api/Customer/admin/discard-customer-info",
      "POST",
      payload
    );
  };
  static uploadMandate = async (payload) => {
    return await APICall(
      `/api/NewAccount/admin/upload-mandate`,
      "POST",
      payload
    );
  };

  // minor accounts
  static listMinor = async (
    page,
    pageLimit,
    search,
    from,
    to,
    accountStatus
  ) => {
    return await APICall(
      `/api/MinoAccount/admin/list-minor-account?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&accountStatus=${accountStatus}`,
      "GET"
    );
  };
  static exportMinor = async (search, from, to, accountStatus) => {
    return await APICall(
      `/api/MinoAccount/admin/export-minor-account?search=${search}&from=${from}&to=${to}&accountStatus=${accountStatus}`,
      "GET"
    );
  };
  static viewMinor = async (minorAccountId) => {
    return await APICall(
      `/api/MinoAccount/admin/view-minor-account?minorAccountId=${minorAccountId}`,
      "GET"
    );
  };
  static actionMinor = async (payload) => {
    return await APICall(
      `/api/MinoAccount/admin/action-minor-account`,
      "POST",
      payload
    );
  };

  //   All accounts

  static listUserAccount = async (page, pageLimit, search, from, to) => {
    return await APICall(
      `/api/NewAccount/admin/customer-accounts?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`,
      "GET"
    );
  };
  static exportUserAccount = async (search, from, to) => {
    return await APICall(
      `/api/NewAccount/admin/export-customer-accounts?search=${search}&from=${from}&to=${to}`,
      "GET"
    );
  };

  //Upgrade Account
  static upgradeAccounts = async (
    page,
    pageLimit,
    status,
    startDate,
    endDate,
    search
  ) => {
    let url = `/api/AcccountUpgrade/admin/accounts/upgrade?pageSize=${page}&pageLimit=${pageLimit}`;

    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (search) url += `&search=${search}`;
    if (status) url += `&accountUpgradeStatus=${status}`;
    console.log("url", url);

    return await APICall(url, "GET");
  };

  // sync account
  static syncAccount = async (accountNo, email) => {
    return await APICall(
      `/api/AcccountUpgrade/admin/tier-one-account-sync/trigger?accountNumber=${accountNo}&initiatorEmail=${email}`,
      "POST"
    );
  };

  //Export Account
  static exportAccount = async (
    page,
    pageLimit,
    status,
    startDate,
    endDate,
    search
  ) => {
    let url = `/api/AcccountUpgrade/admin/export-upgrade-account?pageSize=${page}&pageLimit=${pageLimit}`;
    if (status) url += `&accountUpgradeStatus=${status}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (search) url += `&search=${search}`;
    console.log("url", url);

    return await APICall(url, "POST");
  };
}
